<template>
  <v-container
    fluid
    grid-list-md
  >
    <v-layout row wrap>
      <v-flex xs12>
        <v-toolbar flat>
          <h2>Импорт клиентов</h2>
          <div class="px-3"></div>
        </v-toolbar>
      </v-flex>
      <v-flex xs12>
        <v-stepper v-model="curStep" vertical class="elevation-0">
          <v-stepper-step :complete="curStep > 1" step="1">
           Вставьте список
           <small>формат: Ф;И;О;Карта;ИдШколы;ДолжностьИлиКласс;Категория</small>
          </v-stepper-step>

          <v-stepper-content step="1">
           <v-textarea class="mb-5" v-model="icsv" label="вставьте данные сюда"
           @change="step1Error=null"
           >
           </v-textarea>
           <v-alert color="error" v-if="step1Error">
             {{ step1Error }}
           </v-alert>
           <v-btn class="mr-3" color="primary" :disabled="step1Error !== null" @click="goStep2()">Продолжить</v-btn>
           <v-btn text @click="drop()">Отмена</v-btn>
          </v-stepper-content>

          <v-stepper-step :complete="curStep > 2" step="2">
            Проверка карт
            <small v-if="curStep > 1">Для {{newpersons.length}} записей</small>
          </v-stepper-step>

          <v-stepper-content step="2">
            <v-alert color="error" v-if="step2Error">
              {{ step2Error }}
            </v-alert>
            <v-card tile flat>
              <v-card-text>
                <div class="headline" v-html="cardchecklog"></div>
              </v-card-text>
            </v-card>
            <v-card tile flat>
              <v-card-text>
                <v-alert color="primary">
                  Загружены ранее: {{skipped}}
                </v-alert>
                <v-alert color="error">
                  Пропущены из-за ошибок: {{errored}}
                </v-alert>
                <v-alert color="info">
                  Будут загружены: {{beimported}}
                </v-alert>
              </v-card-text>
            </v-card>
            <v-btn class="mr-3" color="primary" :disabled="step2Error !== null || beimported === 0 || inaction === true" @click="goStep3()">Продолжить</v-btn>
            <v-btn text @click="drop()">Отмена</v-btn>
          </v-stepper-content>

          <v-stepper-step :complete="curStep > 3" step="3">
            Грузим
            <small v-if="curStep > 2">
              Загружены ранее: {{skipped}} &nbsp;
              Пропущены из-за ошибок: {{errored}} &nbsp;
              Загружены: {{imported.length}}
            </small>
          </v-stepper-step>

          <v-stepper-content step="3">
            <p v-for="item in imported">
              {{ item}}
            </p>
            <v-alert color="error" v-if="step3Error">
             {{ step3Error }}
            </v-alert>
            <v-btn v-if="done" class="mr-3" color="primary" :disabled="step3Error !== null" @click="drop()">Готово!</v-btn>
          </v-stepper-content>

        </v-stepper>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  name: 'ImportPersons',
  data: () => ({
    curStep: 1,
    step1Error: null,
    step2Error: null,
    step3Error: null,
    icsv: '',
    positions: '',
    schools: '',
    newpersons: [],
    cardchecklog: '',
    skipped: 0,
    errored: 0,
    beimported: 0,
    inaction: false,
    imported: [],
    done: false,
  }),
  methods: {
    drop () {
      this.curStep = 1
      this.step1Error = null
      this.step2Error = null
      this.step3Error = null
      this.icsv = ''
      this.positions = ''
      this.schools = ''
      this.newpersons = []
      this.cardchecklog = ''
      this.skipped = 0
      this.errored = 0
      this.beimported = 0
      this.inaction = false
      this.imported = []
      this.done = false
    },
    async goStep2 () {
      if (this.curStep !== 1) return
      try {
        this.inaction = true
        if (!this.icsv || this.icsv.length === 0) throw new Error('Вставьте данные')
        // fetching server state
        const { positions } = await this.$store.dispatch('sioRequest', {
          topic: 'filter-positions', pl: { limit: 1000000 }
        })
        this.positions = positions
        const { schools } = await this.$store.dispatch('sioRequest', {
          topic: 'fetch-schools'
        })
        this.schools = schools
        // parse
        function arestudents (label) {
          if (label.toLowerCase() === 'ученик') return true
          if (label.toLowerCase() === 'сотрудник') return false
          throw new Error('Нужно указать значение ученик/сотрудник')
        }
        const recs = this.icsv
        .split('  ').join(' ')
        .split('ё').join('е')
        .split('Ё').join('Е')
        .split('\r')
        .join('')
        .split('\n')
        .filter(x => x.includes(';'))

        this.newpersons = []

        for (let x of recs) {
          const vals = x.split(';')
          if (vals.length !== 7) throw new Error(`Неполноценная запись: "${x}"`)
          const newperson = ({
            rec: x,
            fullname: `${vals[0]} ${vals[1]} ${vals[2]}`,
            cardid: vals[3],
            schoolid: vals[4],
            positionname: vals[5],
            arestudents: arestudents(vals[6]),
            school: this.schools.find(x => x.schoolid === vals[4])
          })
          if (!newperson.school) throw new Error(`Неизвестная школа  ${newperson.schoolid}`)
          newperson.position = this.positions.find(x => x.arestudents === newperson.arestudents && x.schoolid === newperson.schoolid && x.name === newperson.positionname)
          if (!newperson.position) {
            const { position, meta } = await this.$store.dispatch('sioRequest', {
              topic: 'add-position', pl: {
                name: newperson.positionname,
                arestudents: newperson.arestudents,
                schoolid: newperson.schoolid
              }
            })
            this.$store.dispatch('snack', meta)
            newperson.position = position
            this.positions.push(position)
          }
          this.newpersons.push(newperson)
        }
        if (!this.newpersons || !this.newpersons.length) throw new Error('Нечего загружать')
        this.curStep = 2
        try {
          // await this.$store.dispatch('confirm', `Точно грузим?`)
          for (let newperson of this.newpersons) {
            const { card } = await this.$store.dispatch('sioRequest', {
              topic: 'fetch-card', pl: { cardid: ('000' + newperson.cardid).slice(-9) }
            })
            if (!card) {
              newperson.skip = true
              this.cardchecklog += `<b style="color:crimson">КАРТА НЕ НАЙДЕНА: ${newperson.rec}</b><br />`
              this.errored++
            } else if (card.personid) {
              newperson.skip = true
              const { person } = await this.$store.dispatch('sioRequest', {
                topic: 'fetch-person', pl: { personid: card.personid }
              })
              if (person.fullname !== newperson.fullname) {
                newperson.skip = true
                this.cardchecklog += `<b style="color:crimson">КАРТА ЗАНЯТА ${person.fullname}, ФИО НЕ СОВПАДАЕТ: ${newperson.rec}</b><br />`
                this.errored++
              } else {
                this.skipped++
              }
            } else {
              this.beimported++
            }
            newperson.card = card
          }
        } catch (e) {
          this.$store.dispatch('snack', e)
          this.step2Error = e
        }
      } catch (e) {
        this.$store.dispatch('snack', e)
        this.step1Error = e
      } finally {
        this.inaction = false
      }
    },
    async goStep3 () {
      this.curStep = 3
      try {
        // await this.$store.dispatch('confirm', `Точно грузим?`)
        for (let newperson of this.newpersons.filter(x => !x.skip)) {
          const { person } = await this.$store.dispatch('sioRequest', {
            topic: 'add-person',
            pl: newperson
          })
          const { personid } = person
          await this.$store.dispatch('sioRequest', {
            topic: 'update-position',
            pl: { personid, positionid: newperson.position.positionid }
          })
          await this.$store.dispatch('sioRequest', {
            topic: 'card-take',
            pl: { personid, cardid: newperson.card.cardid }
          })
          this.imported.push(newperson.rec)
        }
      } catch (e) {
        this.$store.dispatch('snack', e)
        this.step3Error = e
      } finally {
        this.done = true
      }
    },
  },
  computed: {
    uniquePositions () {
      try {
        const res = this.newpersons.reduce((r, x) => {
          if (!r.find(y => y.schoolid === x.schoolid && y.name === x.name)) {
            r.push({ schoolid: x.schoolid, name: x.name })
          }
          return r
        }, [])
        return res
      } catch (e) {
        this.$store.dispatch('snack', e)
      }
    },
    profile () {
      return this.$store.state.profile
    }
  },
  watch: {
    async profile (val) {
    }
  },
  mounted () {
  }
}
</script>

<style>
</style>
